import { render } from "./Contact.vue?vue&type=template&id=39620b78&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=39620b78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39620b78"]])

export default __exports__